<div class="content-block">
    <div class="row">
    <h4>Scegli l'articolo dalla lista sottostante</h4>
    </div>
    <div class="row">
        <dx-lookup [displayExpr]="getArticoloDisplayExpr" valueExpr="id" [dataSource]="listArticoli"
                [searchEnabled]="true" [(value)]="idArticolo">
              </dx-lookup>
    </div>
    <div class="row div-button">
        <dx-button stylingMode="contained" type="danger" text="Annulla" (onClick)="onAnnullaArticolo()" width="150">
        </dx-button>

        <dx-button stylingMode="contained" type="success" text="Conferma" (onClick)="onScegliArticolo()" width="150">
        </dx-button>
    </div>
</div>